import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=6095efed"
import script from "./teamMember.vue?vue&type=script&lang=js"
export * from "./teamMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports